/// <reference types="vite/client" />

// Alpine
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)

// Components
import { initHeader } from './default/header'
import { initCollapsible } from './default/collapsible'
import { initIntersectObserver } from './default/intersect-observer'
import { initJSEssentials } from './default/js-essentials'
import { initSlider } from './default/slider'
import { initBasket } from './default/basket'
import { initDialog } from './default/dialog'
import { initFilters } from './default/filters'
import { initVacancyFilter } from './default/vacancyFilter'
import { initVdpImageSlider } from './default/vdp-image-slider'
import { videoEmbedLoader } from './default/video-loader'
import { initSpeculationRules } from './default/speculation-rules'
import { initOnlineafspraken } from './default/online-afspraken.ts'
import { initPictureViewer } from './default/picture-viewer.ts'
import { initFinanceTool } from './default/finance-tool'
initCollapsible()
initHeader()
initIntersectObserver()
initJSEssentials()
initSlider()
initBasket()
initDialog()
initFilters()
initVacancyFilter()
initVdpImageSlider()
videoEmbedLoader()
initSpeculationRules()
initOnlineafspraken()
initPictureViewer()
initFinanceTool()

Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        // eslint-disable-next-line no-console
        console.log('HMR')
    })
}
